<template>
  <b-container class="content-wrapper">
    <terms-of-service-paragraph subtitleTag="tos-sub-title1" :paragraphs="['tos-paragraph11', 'tos-paragraph12', 'tos-paragraph13']"/>
    <terms-of-service-paragraph subtitleTag="tos-sub-title2" :paragraphs="['tos-paragraph21', 'tos-paragraph22', 'tos-paragraph23', 'tos-paragraph24', 'tos-paragraph25']"/>
    <terms-of-service-paragraph subtitleTag="tos-sub-title3" :paragraphs="['tos-paragraph31', 'tos-paragraph32', 'tos-paragraph33', 'tos-paragraph34', 'tos-paragraph35']"/>
    <terms-of-service-paragraph subtitleTag="tos-sub-title4" :paragraphs="['tos-paragraph41', 'tos-paragraph42']"/>
    <terms-of-service-paragraph subtitleTag="tos-sub-title5" :paragraphs="['tos-paragraph51', 'tos-paragraph52', 'tos-paragraph53']"/>
    <terms-of-service-paragraph subtitleTag="tos-sub-title6" :paragraphs="['tos-paragraph61', 'tos-paragraph62', 'tos-paragraph63']"/>
    <terms-of-service-paragraph subtitleTag="tos-sub-title7" :paragraphs="['tos-paragraph71', 'tos-paragraph72', 'tos-paragraph73']"/>
    <terms-of-service-paragraph subtitleTag="tos-sub-title8" :paragraphs="['tos-paragraph81', 'tos-paragraph82']"/>
    <terms-of-service-paragraph subtitleTag="tos-sub-title9" :paragraphs="['tos-paragraph91']"/>
  </b-container>
</template>

<script>
import TermsOfServiceParagraph from './TermsOfServiceParagraph'
export default {
  name: 'TermsOfService',
  components: {
    TermsOfServiceParagraph
  }
}
</script>

<style scoped>
  .content-wrapper {
    background: var(--white);
    padding-top: 1em;
    margin-top: 1em;
    margin-bottom: 1em;
  }
</style>
